import { zodResolver } from '@hookform/resolvers/zod';
import { ReactNode } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { z } from 'zod';
import { CustomEventValues, UserFieldValues } from '../types';

const schema = z.object({
  customEventValue: z.nativeEnum(CustomEventValues),
  userFieldValue: z.nativeEnum(UserFieldValues),
});

type SettingsFormProviderProps = {
  children: ReactNode;
  customEventValue: CustomEventValues;
  userFieldValue: UserFieldValues;
};

export const SettingsFormProvider = ({
  children,
  customEventValue,
  userFieldValue,
}: SettingsFormProviderProps) => {
  const defaultValues = {
    customEventValue,
    userFieldValue,
  };

  const methods = useForm({
    defaultValues,
    mode: 'onSubmit',
    resolver: zodResolver(schema),
    reValidateMode: 'onChange',
  });

  return <FormProvider {...methods}>{children}</FormProvider>;
};
